// @flow
import React, { type Node } from 'react';
import classNames from 'classnames/bind';
import { Scrollbars } from 'react-custom-scrollbars-2';

import styles from './ProductGallery.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  imgSrc: string,
  title?: string,
  children: Node,
  vertical?: boolean,
}

const ProductGallery = ({ imgSrc, title, children, vertical }: Props) => (
  <div className={cx(styles.root, { vertical })}>
    <div className={styles.image}>
      <img src={imgSrc} alt={title} />
    </div>
    <div className={cx(styles.thumbs, { vertical })}>
      {vertical
        ? <Scrollbars>
          {children}
        </Scrollbars>
        : children}
    </div>
  </div>
);

export default ProductGallery;
